import "./colunistas.css";
import { useEffect, useState } from "react";
import api from "../../constants/api.js";
import Modal from "../../components/modal/modal.jsx";
import { useNavigate } from "react-router-dom";
import BtnVoltar from "../../components/btn-voltar/btn-voltar.jsx";
import Swal from "sweetalert2";

function Colunistas() {
  const [colunistas, setColunistas] = useState([]);
  const [open, setOpen] = useState(false);
  const [editandoId, setEditandoId] = useState(null);
  const [titulo, setTitulo] = useState(""); // nome do colunista
  const [texto, setTexto] = useState(""); // NÃO USADO, mas mantido p/ modal global
  const [img, setImg] = useState(null);

  const navigate = useNavigate();

  /* =========================
     BUSCAR COLUNISTAS
  ========================= */
  useEffect(() => {
    async function fetchColunistas() {
      try {
        const response = await api.get("/colunistas");
        setColunistas(response.data || []);
      } catch (error) {
        console.log(
          error.response?.data?.error ||
            "Ocorreu um erro, tente novamente mais tarde"
        );
      }
    }

    fetchColunistas();
  }, []);

  /* =========================
     NAVEGAÇÕES
  ========================= */
  function abrirPostColunista(id_colunista) {
    navigate(`/admin/colunistas/${id_colunista}/posts`);
  }

  function voltar() {
    navigate("/home");
  }

  /* =========================
     MODAL
  ========================= */
  function abrirModal() {
    setTitulo("");
    setImg(null);
    setEditandoId(null);
    setOpen(true);
  }

  function editarColunista(colunista) {
    setTitulo(colunista.nome);
    setImg(colunista.foto);
    setEditandoId(colunista.id_colunista);
    setOpen(true);
  }

  /* =========================
     INSERIR COLUNISTA
  ========================= */
  async function enviarPost() {
    // ✅ VALIDAÇÃO
    if (!titulo.trim()) {
      throw new Error("Nome do colunista é obrigatório");
    }

    try {
      const formData = new FormData();
      formData.append("nome", titulo);

      if (img) {
        formData.append("foto", img);
      }

      const response = await api.post("/colunistas", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      const novoColunista = {
        id_colunista: response.data.id_colunista,
        nome: response.data.nome,
        foto: response.data.foto || null,
      };

      

      setColunistas((prev) => [novoColunista, ...prev]);
      setTitulo("");
      setImg(null);
      setOpen(false);
    } catch (error) {
      throw error; // 🔥 propaga para o Modal
    }
  }

  /* =========================
     EDITAR COLUNISTA
  ========================= */
  async function enviarEdit() {
    // ✅ VALIDAÇÃO
    if (!titulo.trim()) {
      throw new Error("Nome do colunista é obrigatório");
    }

    try {
      const formData = new FormData();
      formData.append("nome", titulo);

      if (img && typeof img !== "string") {
        formData.append("foto", img);
      }

      const response = await api.put(
        `/colunistas/${editandoId}`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );

      setColunistas((prev) =>
        prev.map((c) =>
          c.id_colunista === editandoId
            ? { ...c, nome: response.data.nome, foto: response.data.foto }
            : c
        )
      );

      console.log(colunistas)

      setOpen(false);
    } catch (error) {
      throw error;
    }
  }

  /* =========================
     EXCLUIR COLUNISTA
  ========================= */
 async function excluirColunista(id_colunista) {
  const result = await Swal.fire({
    title: "Tem certeza?",
    text: "O colunista será excluído permanentemente",
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Sim, excluir",
    cancelButtonText: "Cancelar",
    confirmButtonColor: "#e53935",
  });

  // 👇 se clicar em cancelar, não faz nada
  if (!result.isConfirmed) return;

  try {
    await api.delete(`/colunistas/${id_colunista}`);

    setColunistas(prev =>
      prev.filter(c => c.id_colunista !== id_colunista)
    );

    Swal.fire({
      icon: "success",
      title: "Excluído!",
      text: "Colunista removido com sucesso",
      timer: 1200,
      showConfirmButton: false,
    });
  } catch (error) {
  Swal.fire({
    icon: "error",
    title: "Não foi possível excluir",
    text:
      error.response?.status === 500
        ? "Este colunista possui postagens vinculadas. Exclua ou remova as postagens antes de apagar o colunista."
        : error.response?.data?.error || "Erro inesperado ao excluir colunista",
  });
}

}

  /* =========================
     RENDER
  ========================= */
  return (
    <div className="container-colunistas">
      <div className="header-colunistas">
        <h2>Colunistas</h2>

        <div className="containerBtn-colunistas">
          <button className="inserir" onClick={abrirModal}>
            Inserir Colunista
          </button>
          <BtnVoltar voltar={voltar} />
        </div>
      </div>

      <div className="lista-colunistas">
        {colunistas.map((colunista) => (
          <div className="colunista" key={colunista.id_colunista}>
            <img src={colunista.foto} alt={colunista.nome} />
            <p>{colunista.nome}</p>

            <div className="btn-colunista">
              <button
                onClick={() =>
                  abrirPostColunista(colunista.id_colunista)
                }
              >
                Abrir Posts
              </button>
              <button onClick={() => editarColunista(colunista)}>
                Editar
              </button>
              <button
                onClick={() =>
                  excluirColunista(colunista.id_colunista)
                }
              >
                Excluir
              </button>
            </div>
          </div>
        ))}

        <Modal
          isOpen={open}
          setOpen={setOpen}
          enviar={editandoId ? enviarEdit : enviarPost}
          tipo="colunista"
          titulo={titulo}
          setTitulo={setTitulo}
          texto={texto}
          setTexto={setTexto}
          img={img}
          setImg={setImg}
          placeholderTitulo="Digite o nome do colunista"
        />
      </div>
    </div>
  );
}

export default Colunistas;
